import { Form, Input } from "decorator-form";
import { css } from "styled-components";

import InputType from "common/form/InputType";
import SubFormWidget from "common/form/widgets/SubFormWidget";

@Form({title: "Typography Styles"})
export class TypographyStylesConfig {

	@Input({type: InputType.TEXT, title: "Font Family"})
	public fontFamily?: string;

	@Input({type: InputType.UNIT, title: "Font Size"})
	public fontSize?: string;

	@Input({type: InputType.FONT_WEIGHT, title: "Font Weight"})
	public fontWeight?: string;

	@Input({type: InputType.TEXT, title: "Font Style"})
	public fontStyle?: string;

	@Input({type: InputType.UNIT, title: "Line Height"})
	public lineHeight?: string;

	@Input({type: InputType.UNIT, title: "Letter Spacing"})
	public letterSpacing?: string;

	@Input({type: InputType.TEXT_TRANSFORM, title: "Text Transform"})
	public textTransform?: string;

	@Input({type: InputType.ALIGNMENT, title: "Align Text"})
	public textAlign?: string;
}

export const typographyStylesInput = SubFormWidget.registerForm(TypographyStylesConfig);

export function toTypographyCss(data: TypographyStylesConfig) {
	return data ? css`
		font-family: ${data.fontFamily};
		font-style: ${data.fontStyle};
		font-size: ${data.fontSize};
		line-height: ${data.lineHeight};
		letter-spacing: ${data.letterSpacing};
		font-weight: ${data.fontWeight};
		text-transform: ${data.textTransform};
		text-align: ${data.textAlign};
	` : undefined;
}



// WEBPACK FOOTER //
// ./src/common/views/common/TypographyStylesConfig.ts